import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { ApiOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/equipment',
    name: 'equipment_layout',
    redirect: '/equipment/index',
    component: Layout,
    meta: {
      title: 'Equipment',
      icon: renderIcon(ApiOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: ['equipment_read'],
      sort: 4,
      isRoot: true,
    },
    children: [
      {
        path: 'index',
        name: 'equipment',
        meta: {
          title: 'Equipment',
          // icon: renderIcon(ApiOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['equipment_read'],
        },
        component: () => import('@/views/equipment/index.vue'),
      },
    ],
  },
];

export default routes;
